export default __webpack_public_path__ + "static/media/ARPHICPL.67393f93.TXT";